import React from "react";

import { makeStyles } from "@material-ui/core";

import Button from "@ds-developer/button";
import RadioButtons from "@ds-developer/radio-buttons";

import { SalutationButtonsProps } from "./types";

const useStyles = (error: boolean) =>
  makeStyles(theme => ({
    salutationButton: {
      margin: theme.spacing(1, 0),
      marginTop: theme.spacing(2),
      color: error ? theme.palette.error.main : "auto",
    },
    container: error
      ? {
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: theme.palette.error.main,
          borderRadius: 4,
          display: "flex",
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
          position: "relative",
        }
      : {
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: theme.palette.grey[400],
          borderRadius: 4,
          display: "flex",
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
          position: "relative",
        },
    label: {
      position: "absolute",
      top: -8,
      left: 10,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(0, 0.5),
      color: error ? theme.palette.error.main : theme.palette.grey[500],
      fontSize: theme.typography.caption.fontSize,
      fontWeight: theme.typography.fontWeightBold,
      zIndex: 1,
      pointerEvents: "none",
    },
  }));

const SalutationButtons: React.FC<SalutationButtonsProps> = ({
  salutations,
  onChange = () => {},
  value,
  disabled = false,
  error,
  label,
}) => {
  const classes = useStyles(Boolean(error))();
  return (
    <div className={classes.container}>
      {label && <label className={classes.label}>{label}</label>}
      <RadioButtons fullWidth label="" onChange={onChange} value={value}>
        {salutations.map(salutationOption => (
          <Button
            className={classes.salutationButton}
            disabled={disabled && value !== salutationOption}
            key={salutationOption}
            value={salutationOption}
            data-test={`salutation-radio-button-${salutationOption.toLowerCase()}`}
          >
            {salutationOption}
          </Button>
        ))}
      </RadioButtons>
    </div>
  );
};

export default SalutationButtons;
